import { Form, mapFormDispatchToEvents } from '@elab/components/connected/forms/Form';
import { COMPONENT_CONNECT, COMPONENT_DISCONNECT } from '@elab/core/utils/dynaReduxHelpers';
import connect from '@elab/core/store/connect';
import { actions as coreActions } from '@elab/core/store/core';

import { actions, reducers, sagaFactory, storeName } from './redux';

export class PersonalInformationForm extends Form {
    static get properties() {
        return {
            skipPhonePrefill: {
                type: Boolean,
                attribute: 'skip-phone-prefill',
            },
        };
    }

    constructor() {
        super();
        this.storeName = storeName;
        this.otherErrorText = '';
        this.validationErrorText = '';
        this.skipPhonePrefill = false;
    }

    afterConnect() {
        super.afterConnect();
        this.dispatchEvent(
            new CustomEvent('SKIP_PHONE_PREFILL', {
                detail: { skipPhonePrefill: this.skipPhonePrefill },
            }),
        );
    }
}

export class PersonalInformationCheckoutForm extends PersonalInformationForm {
    afterConnect() {
        this.dispatchEvent(new CustomEvent('COMPONENT-CONNECT'));
        this.dispatchEvent(new CustomEvent('DO_ADDRESS_VERIFICATION'));
    }
}

const mapDispatchToEvents = (dispatch, ctx) => ({
    [COMPONENT_CONNECT]: () => {
        dispatch(coreActions.addReducer(storeName, reducers));

        const saga = sagaFactory(ctx.formId);
        dispatch(coreActions.addSaga(storeName, saga));
    },
    [COMPONENT_DISCONNECT]: () => {
        dispatch(coreActions.removeSaga(storeName));
        dispatch(coreActions.removeReducer(storeName));
    },
    DO_ADDRESS_VERIFICATION: () => {
        dispatch(actions.doAddressVerification());
    },
    SKIP_PHONE_PREFILL: ({ detail: { skipPhonePrefill } }) => {
        dispatch(actions.setSkipPhonePrefill(skipPhonePrefill));
    },
    ...mapFormDispatchToEvents(dispatch, ctx),
});

export default () => {
    customElements.define(
        'e2-personal-information-form',
        connect(null, mapDispatchToEvents)(PersonalInformationForm),
    );
    customElements.define(
        'e2-personal-information-checkout-form',
        connect(null, mapDispatchToEvents)(PersonalInformationCheckoutForm),
    );
};
